import React from "react";
import { Box, Popover } from "@mui/material";

const CustomPopper = ({
  children,
  isPopperOpen,
  setIsPopperOpen,
  anchorOrigin = {
    vertical: "top",
    horizontal: "right",
  },
}) => {
  const handleClose = () => {
    setIsPopperOpen(null);
  };

  const open = Boolean(isPopperOpen);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <Popover
        id={id}
        open={open}
        anchorEl={isPopperOpen}
        onClose={handleClose}
        anchorOrigin={anchorOrigin}
      >
        <Box sx={{ p: 2 }}>{children}</Box>
      </Popover>
    </div>
  );
};

export default CustomPopper;
